import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import store from 'store';

import UserService from 'services/user.service';

import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import { Button } from 'components/Button';
import RadioInput from 'components/RadioInput';
import Form from 'components/Form';
import Input from 'components/Input';
import toast from 'components/Toast/dispatch';

import IconSuccess from 'img/success-img.svg';

const AddNewUser: React.FC = () => {
  const slider = useSelector((state: RootState) => state.slider);
  const [loading, setLoading] = useState(false);
  const [wasLinked, setWasLinked] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [newUserData, setNewUserData] = useState<any>({
    email: '',
    roles: ['administrator'],
    profileType: ['CUSTOMER'],
  });

  const dispatch = useDispatch();
  const _userService = new UserService();
  const { customer } = store.getState();
  const user = useSelector((state: RootState) => state.user);

  async function inviteUser(forceInvite?: boolean) {
    setLoading(true);
    setErrorMessage('');

    let customerId;

    if (customer?.id) {
      customerId = customer.id;
    } else if (user?.customerId) {
      customerId = user.customerId;
    } else if (user?.selectedCustomerId) {
      customerId = user.selectedCustomerId;
    }

    await _userService
      .invite(
        newUserData.email,
        newUserData.roles,
        newUserData.profileType,
        customerId,
        forceInvite
      )
      .then((result: any) => {
        if (result?.status === 200) {
          if (result.data?.forceInvite) {
            toast.yesNo(
              'Gostaria de reenviar o email de vínculo novamente.',
              () => inviteUser(true),
              'Sim',
              'Não'
            );
            setLoading(false);
            return;
          }
          dispatch({ type: 'CLOSE_TOAST' });

          setWasLinked(result.data?.wasLinked ?? false);

          dispatch({ type: 'HIDE_TITLE' });
          return setSuccess(true);
        }

        setErrorMessage(
          result.response.data.data || 'Ocorreu um erro durante a requisição.'
        );
        setLoading(false);
      });
  }

  function getSucessMessage() {
    return wasLinked
      ? 'Identificamos que o usuário já possui cadastro no Customer Care.' +
      '\nEle receberá por e-mail uma notificação informando a inclusão do acesso a essa empresa'
      : 'O usuário receberá por e-mail um link para completar seu cadastro';
  }

  function onCloseSlider() {
    if (slider?.state?.currentPage > 0) {
      slider?.state?.setCurrentPage(0);
    } else {
      slider?.state?.getUsers();
    }
    dispatch({ type: 'CLOSE_SLIDER' });
    dispatch({ type: 'SHOW_TITLE' });
  }

  return !success ? (
    <Form
      className="flex-1"
      id="add_new_user_form"
      onValidate={() => inviteUser(false)}
    >
      <Column className="mt-3 flex-1">
        <Column>
          <Text className="color-blue-gray mb-2">E-mail</Text>
          <Input
            required
            onChange={(e: any) =>
              setNewUserData({ ...newUserData, email: e.target.value.toLowerCase() })
            }
            className="w-100"
            type="email"
            value={newUserData.email}
            placeholder="E-mail"
          />
        </Column>
        <Column className="mt-3">
          <Text className="color-blue-gray mb-2">Nível de acesso</Text>
          <Row>
            <Row className="mr-2">
              <RadioInput
                id="radio_administrator"
                onClick={() =>
                  setNewUserData({ ...newUserData, roles: ['administrator'] })
                }
                checked={
                  newUserData.roles && newUserData.roles[0] === 'administrator'
                }
              >
                <Text>Administrador</Text>
              </RadioInput>
            </Row>
            <Row>
              <RadioInput
                id="radio_collaborator"
                onClick={() =>
                  setNewUserData({ ...newUserData, roles: ['member'] })
                }
                checked={newUserData.roles && newUserData.roles[0] === 'member'}
              >
                <Text>Colaborador</Text>
              </RadioInput>
            </Row>
          </Row>
        </Column>
        {errorMessage && (
          <Row className="mt-2">
            <Text size={12} className="animated fadeIn mt-1 color-danger">
              {errorMessage}
            </Text>
          </Row>
        )}
        <Row className="mt-3 align-center justify-center">
          <Button
            form="add_new_user_form"
            spinnerColor="#0E4C54"
            isRequesting={loading}
            disabled={loading}
            className="outline bg-primary flex-sm-1 align-center justify-center d-flex"
          >
            <Text className="color-primary font-bold">Enviar Convite</Text>
          </Button>
        </Row>
      </Column>
    </Form>
  ) : (
    <Column className="w-100 h-100 align-center justify-center">
      <img src={IconSuccess} alt="" />
      <Text className="mt-2 color-blue-gray font-bold">
        Convite enviado com sucesso
      </Text>
      <Text className="text-center text-wrap mt-3 color-blue-gray" size={12}>
        {getSucessMessage()}
      </Text>
      <Button onClick={onCloseSlider} className="outline mt-4" width="auto">
        <Text className="color-primary font-bold px-3">Fechar</Text>
      </Button>
    </Column>
  );
};

export default AddNewUser;
